import Lenis from '@studio-freight/lenis';

export const modal = () => {
  /**
   * モーダルウィンドウ
   */
  {
    const $openArr = [...document.querySelectorAll('.js-modal__open')];
    const $closeArr = [...document.querySelectorAll('.js-modal__close')];

    $openArr.forEach(($open, i) => {
      const id = $open.dataset.id || `modal${String(i + 1).padStart(2, 0)}`;
      const $modal = document.getElementById(id);

      $open.addEventListener('click', () => {
        $modal.classList.add('is--active');
        LENIS.destroy();
        document.body.style.overflow = 'hidden';
      });
    });

    $closeArr.forEach($close => {
      const $modal = $close.closest('.js-modal');

      $close.addEventListener('click', () => {
        $modal.classList.remove('is--active');
        LENIS = new Lenis();
        document.body.style.overflow = null;
      });
    });
  }
};
